import { useParams } from "react-router-dom";
import useScreenName from "../../hooks/useScreenName";
import UnderwritingUiFrame from "./UnderwritingUiFrame";
import UnderwritingUiPageShell from "./UnderwritingUiPageShell";
import { UNDERWRITING_UI_EMBED_PAGES } from "./underwritingUi.constants";
import useUnderwritingUiEmbedUrl from "./useUnderwritingUiEmbedUrl";

export default function PolicyDetailsEmbedPage() {
  useScreenName("Underwriting UI");
  const { policyName = "" } = useParams() as { policyName: string };
  const { embedUrl, isLoading, error } = useUnderwritingUiEmbedUrl(
    policyName
      ? { page: UNDERWRITING_UI_EMBED_PAGES.POLICY_DETAILS, policyName }
      : null,
    "Policy name required"
  );

  return (
    <UnderwritingUiPageShell title="Policy details">
      <UnderwritingUiFrame
        title={`Policy details ${policyName}`}
        embedUrl={embedUrl}
        isLoading={isLoading}
        error={error}
        loadingText="Loading policy details..."
      />
    </UnderwritingUiPageShell>
  );
}
